import { Component, Input } from '@angular/core';

@Component({
  selector: 'emiplus-check',
  templateUrl: './input-check.component.html',
  styleUrls: ['./input-check.component.scss']
})
export class InputCheckComponent{
  @Input() Actiavte: boolean;
  constructor() {
    this.Actiavte = false;
  }
}
